<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        v-if="pendencyData && pendencyData.driverName"
        back="back"
        title
        :content="`Detalhes da Pendência ${pendencyData.driverName} `"
      ></el-page-header>
      <el-page-header
        v-else
        back="back"
        title
        :content="`Detalhes da Pendência`"
      ></el-page-header>
    </el-card>
    <el-card shadow="always">
      <el-descriptions
        class="margin-top"
        :title="tableItem.name"
        :column="3"
        border
        v-for="tableItem of tableHistory"
        :key="tableItem.id"
      >
        <el-descriptions-item :span="3">
          <template slot="label">
            <i class="el-icon-user"></i>
            Cliente
          </template>
          <span>
            {{ tableItem.name }}
          </span>
        </el-descriptions-item>

        <el-descriptions-item :span="2">
          <template slot="label">
            <i class="el-icon-user"></i>
            Endereço
          </template>
          <span>
            {{ tableItem.formatted }}
          </span>
          <el-link class="right" type="primary" @click="route"
            >Ver mapa</el-link
          >
        </el-descriptions-item>
        <el-descriptions-item :span="2">
          <template slot="label">
            <i class="el-icon-user"></i>
            Horário
          </template>
          <span>
            {{ tableItem.time }}
          </span>
        </el-descriptions-item>
        <el-descriptions-item :span="2">
          <template slot="label">
            <i class="el-icon-user"></i>
            Descrição
          </template>
          <span>
            {{
              tableItem.history 
                ? tableItem.history.description
                : "Aguardando reporte"
            }}
          </span>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i>
            Data
          </template>
          <span>
            {{
              tableItem.history 
                ? tableItem.history.createdAt
                : "" | dateFormater
            }}
          </span>
        </el-descriptions-item>
        <el-descriptions-item :span="2">
          <template slot="label">
            <i class="el-icon-user"></i>
            Status
          </template>
          <span v-if="tableItem.status === 'not_collected'">
            <i
              class="fa fa-exclamation-triangle"
              aria-hidden="true"
              style="color: red"
            ></i>
            Não foi realizada a coleta
          </span>
          <span v-else-if="tableItem.status === 'collected'">
            <i
              class="fa fa-check-circle-o"
              aria-hidden="true"
              style="color: green"
            ></i>
            Coletada realizada com sucesso
          </span>
          <span v-else-if="tableItem.status === 'current'">
            <i
              class="fa fa-info-circle"
              aria-hidden="true"
              style="color: orange"
            ></i>
            Motorista está realizando essa rota
          </span>
          <span v-else-if="tableItem.status === 'waiting'">
            <i
              class="fa fa-info-circle"
              aria-hidden="true"
              style="color: blue"
            ></i>
            Aguardando inicio da rota
          </span>
          <div style="display: flex; justify-content: flex-end">
            <el-link
              v-if="tableItem.status === 'collected'"
              class="right"
              type="primary"
              style="margin-right: 15px"
              @click="viewCollect(tableItem.id)"
            >
              Objetos Coletados
            </el-link>
            <el-link
              class="right"
              type="primary"
              @click="
                route(tableItem.started, tableItem.geometry, tableItem.marker)
              "
            >
              Ver rota
            </el-link>
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
import { RouteService } from "@/services/umov/route.services";
import TravelMap from "./components/TravelMap";

import moment from "moment";
import "moment/locale/pt-br";

export default {
  name: "RouteRealTime",
  components: {
    TravelMap,
  },
  mounted() {
    if (this.$route.query.id) this.id = this.$route.query.id;
    console.log(this.$route.query.id);
    this.fetch();
  },
  data() {
    return {
      id: "",
      pendencyData: {
        driverName: "",
      },
      tableHistory: [],
    };
  },
  methods: {
    route(started, actual, marker) {
      const vm = this;
      vm.markers = [];
      if (started) {
        vm.markers.push({
          geometry: {
            customer: "1",
            lat: +started.lat,
            lng: +started.lng,
          },
          address: {
            geometry: {
              customer: "1",
              lat: +started.lat,
              lng: +started.lng,
            },
          },
        });
      }
      vm.markers.push({
        geometry: {
          customer: "2",
          lat: +actual.lat,
          lng: +actual.lng,
        },
        address: {
          geometry: {
            lat: +actual.lat,
            lng: +actual.lng,
          },
        },
      });
      vm.markers.push({
        geometry: {
          customer: "3",
          lat: +marker.lat,
          lng: +marker.lng,
        },
        address: {
          geometry: {
            lat: +marker.lat,
            lng: +marker.lng,
          },
        },
      });
      console.log("vm.markers", vm.markers);
      setTimeout(() => {
        vm.map = true;
      }, 200);
    },

    viewCollect(pendency_id) {
      this.$router.push({
        name: "route.objects.history",
        params: { pendency_id },
      });
    },

    view(lat, lng) {
      const vm = this;
      this.lat = +lat;
      this.lng = +lng;
      this.markers = [];
      this.markers.push({
        geometry: {
          customer: "1",
          lat: +lat,
          lng: +lng,
        },
        address: {
          geometry: {
            customer: "1",
            lat: +lat,
            lng: +lng,
          },
        },
      });
      this.markers.push({
        geometry: {
          customer: "2",
          lat: +lat,
          lng: +lng,
        },
        address: {
          geometry: {
            lat: +lat,
            lng: +lng,
          },
        },
      });
      setTimeout(() => {
        vm.map = true;
      }, 200);
    },

    back() {
      this.$router.push({ name: "home" });
    },

    fetch() {
      const vm = this;
      if (!vm.id) return false;
      const loading = vm.$loading(vm.$options.loading);
      RouteService.get(vm.id)
        .then((response) => {
          vm.pendencyData = response;
          vm.tableHistory = response.markers;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  filters: {
    dateFormater: (date) => moment(date).format("DD/MM/yyyy HH:mm"),
  },
};
</script>

<style>
.late {
  background: #fde2e2;
}
.ontime {
  background: #e1f3d8;
}
.margin-top {
  margin-top: 20px;
}
</style>
